var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3F4FF"
    },
    d: "M459.148,439.554L304,177.394V32c0-4.418-3.578-8-8-8s-8,3.582-8,8h-64c0-4.418-3.578-8-8-8 s-8,3.582-8,8v145.394L52.852,439.554c-8.898,15.027-9.039,33.055-0.391,48.223S76.695,512,94.156,512h323.687 c17.461,0,33.047-9.055,41.695-24.223C468.187,472.609,468.047,454.582,459.148,439.554z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#53DCFF"
    },
    d: "M256,32h-32c0-4.418-3.578-8-8-8s-8,3.582-8,8v145.394L52.852,439.554 c-8.898,15.027-9.039,33.055-0.391,48.223S76.695,512,94.156,512H256V32z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00E68C"
    },
    d: "M431.617,455.851l-44.937-75.926c-1.438-2.434-4.055-3.926-6.883-3.926H132.203 c-2.828,0-5.445,1.492-6.883,3.926l-44.93,75.926c-3.008,5.078-3.062,10.934-0.133,16.082c2.938,5.125,8,8.066,13.898,8.066 h323.687c5.898,0,10.961-2.941,13.906-8.082C434.672,466.789,434.625,460.933,431.617,455.851z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00BEBE"
    },
    d: "M256,376H132.203c-2.828,0-5.445,1.492-6.883,3.926l-44.93,75.926 c-3.008,5.078-3.062,10.934-0.133,16.082c2.938,5.125,8,8.066,13.898,8.066H256V376z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C546A"
    },
    d: "M280,264h-48c-4.422,0-8-3.582-8-8s3.578-8,8-8h48c4.422,0,8,3.582,8,8S284.422,264,280,264z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C546A"
    },
    d: "M280,304h-48c-4.422,0-8-3.582-8-8s3.578-8,8-8h48c4.422,0,8,3.582,8,8S284.422,304,280,304z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C546A"
    },
    d: "M280,344h-48c-4.422,0-8-3.582-8-8s3.578-8,8-8h48c4.422,0,8,3.582,8,8S284.422,344,280,344z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 288,
    cy: 432,
    r: 16
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00E68C"
    },
    cx: 200,
    cy: 408,
    r: 16
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 344,
    cy: 416,
    r: 8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00E68C"
    },
    cx: 224,
    cy: 440,
    r: 8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00E68C"
    },
    cx: 152,
    cy: 424,
    r: 8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44BEF1"
    },
    d: "M304,0l-96,0c-8.837,0-16,7.163-16,16v0c0,8.837,7.163,16,16,16h96c8.837,0,16-7.163,16-16v0 C320,7.163,312.836,0,304,0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlask);
export default __webpack_public_path__ + "static/media/flask.9eea40f98781aba1cff1a1874c453659.svg";
export { ForwardRef as ReactComponent };